module.exports = __webpack_public_path__ + "img/flo_delavega.c3983d3a.jpg";